export default __webpack_public_path__ + "static/media/youtube.1df8173b.PNG";